<template>
  <div class="view-item-image">
    <img v-if="this.src" :src="this.url"/>
    <div v-if="desc" class="desc">{{desc}}</div>
  </div>

</template>

<script>
import utils from './../js/utils'

export default {
  name: 'ImageView',
  props: {
    src: String,
    desc: String
  },
  data () {
    return {}
  },
  computed: {
    url () {
      return this.src ? (utils.url(this.src) + '?v=1') : ''
    }
  }
}
</script>

<style lang="scss">
  img {
    display: block;
    max-width:200px;
  }
  .view-item-image {
    display: inline-block;
    text-align: center;
  }
  .view-item-image .desc {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .exr-view .view-item-image{
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    overflow: hidden;
  }
</style>
